export default class LineruTagsService {

  static general() {
    return {
      lineruLogo: {
        'category': 'lw inicio',
        'action': 'click',
        'label': 'header'
      },
      toRefer: {
        'category': 'lw quiero referir',
        'action': 'scroll',
        'label': 'fold 1'
      },
      copyCode: {
        'category': 'lw quiero referir',
        'action': 'click',
        'label': 'copiar codigo'
      },
      whatsapp: {
        'category': 'lw referral',
        'action': 'click',
        'label': 'whatsapp'
      },
      facebook: {
        'category': 'lw referral',
        'action': 'click',
        'label': 'facebook'
      },
      twitter: {
        'category': 'lw referral',
        'action': 'click',
        'label': 'twitter'
      },
      mailDirect: {
        'category': 'lw referral',
        'action': 'click',
        'label': 'mail direct'
      },
      referNowDiscount: {
        'category': 'lw quiero referir',
        'action': 'scroll',
        'label': 'descuento'
      },
      referralApproved: {
        'category': 'lw quiero referir',
        'action': 'scroll',
        'label': 'referido aprobado'
      },
    }
  }

}
